export const INTEGRATION_FORM = 'INTEGRATION_FORM';

export const INTEGRATION_FORM_INIT = 'INTEGRATION_FORM_INIT';
export const GET_DISTANCES_FOR_INTEGRATIONS = 'GET_DISTANCES_FOR_INTEGRATIONS';
export const CREATE_INTEGRATION = 'CREATE_INTEGRATION';
export const GET_INTEGRATION = 'GET_INTEGRATION';
